/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Enum generated from HubAPI C# code.
export enum HandoverHistoryTypeEnum {
  FullHandover = 1,
  FullOffHire = 2,
  PartialOffHire = 3,
  PartialHandover = 4,
  Variation = 5,
  Adaption = 6,
}
